import { render, staticRenderFns } from "./mobNotice.vue?vue&type=template&id=4c25ab4e&scoped=true&"
import script from "./mobNotice.vue?vue&type=script&lang=js&"
export * from "./mobNotice.vue?vue&type=script&lang=js&"
import style0 from "./mobNotice.vue?vue&type=style&index=0&id=4c25ab4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25ab4e",
  null
  
)

export default component.exports